'use strict';
/**
 *  Module  退稿模板
 *  createBy  CC
 *  reconstructedBy  He.zhikai  2017-1-19
 * Description  2016-1-12
 */
angular.module('editchannelsReviseModule', []).controller('editchannelsReviseCtrl', ['$scope', '$q', '$modalInstance', '$timeout', '$filter', 'initSingleSelecet', 'trsHttpService', 'modalDialog', 'params', 'editingCenterService', 'trsspliceString', 'globleParamsSet', function($scope, $q, $modalInstance, $timeout, $filter, initSingleSelecet, trsHttpService, modalDialog, params, editingCenterService, trsspliceString, globleParamsSet) {
    initStatus();
    initData();

    function initStatus() {
        $scope.status = {
            selectedUser: '',
            treeOptions: Object.assign(editingCenterService.channelTreeOptions(), {
                isSelectable: function(node) {
                    // return node.HASRIGHT === "true" && node.PARENTID !== '0';
                    return node.PARENTID !== '0';
                },
                isLeaf: function(node) {
                    return node.HASCHILDREN == 'false';
                },
            }),
        };
    }

    function initData() {
        getMediaAndPerson();
    }

    /**
     * [getMediaAndPerson description]获得媒体跟人员列表
     * @return {[type]} [description]
     */
    function getMediaAndPerson() {
        var params = {
            serviceid: 'mlf_group',
            methodName: 'queryGroupTreeWithMyPath',
        };
        requestData(params).then(function(data) {
            $scope.treedata = [data];
            expandedNodes();
        });
    }

    /**
     * [expandedNodes description] 默认展开树开始
     * @return {[type]} [description]
     */
    function expandedNodes() {
        $scope.expandedTest = [];
        $scope.expandedTest.push($scope.treedata[0]);
        if ($scope.treedata[0].CHILDREN === 0) {
            $scope.selectedNode = $scope.treedata[0];
            getGroupData($scope.selectedNode);
        } else {
            angular.forEach($scope.treedata[0].CHILDREN, function(data, index, array) {
                if (data.ISPATH === 'true') {
                    $scope.expandedTest.push(data);
                    if (data.CHILDREN.length !== 0) {
                        selfPath(data);
                    } else {
                        $scope.selectedNode = data;
                        getGroupData($scope.selectedNode);
                    }

                }
            });
        }
    }

    /**
     * [userSelect description] 选中人员信息
     * @param  {[type]} user [description]
     * @return {[type]}      [description]
     */
    $scope.userSelect = function(user) {
        $scope.status.selectedUser = user;
    };
    /**
     * [confirm description]确认提交
     * @return {[type]} [description]
     */
    $scope.confirm = function() {
        if ($scope.status.selectedUser.length < 1) {
            modalDialog.alertType('', '请先选择用户', 'error', false, function() {
            });
        } else {
            var xiudingParams = params;
            xiudingParams[xiudingParams.hasOwnProperty('UserId') ? 'UserId' : 'UserIds'] = $scope.status.selectedUser.ID;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), xiudingParams, 'get').then(function(data) {
                modalDialog.multiReportsAlert(data, function() {
                    $modalInstance.close('success');
                });
            }, function() {
                $modalInstance.close();
            });
        }
    };
    /**
     * [showSelected description] 选中当前树节点
     * @param  {[type]} node [description]
     * @return {[type]}      [description]
     */
    $scope.showSelected = function(node) {
        getGroupData(node);
        $scope.status.selectedUser = '';
    };

    /**
     * [selfPath description] 获取路径
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    function selfPath(data) {
        if (data.CHILDREN[0].ISPATH === 'true') {
            if (data.CHILDREN[0].HASCHILDREN === 'false' || data.CHILDREN[0].CHILDREN.length === 0) {
                $scope.selectedNode = data.CHILDREN[0];
                getGroupData($scope.selectedNode);
            } else {
                $scope.expandedTest.push(data.CHILDREN[0]);
                selfPath(data.CHILDREN[0]);
            }
        }
    }

    /**
     * [description]Suggestion 监听
     */
    $scope.$watch('searchWord', function(newValue, oldValue, scope) {
        if (angular.isObject(newValue)) {
            $scope.isRequest = true;
            $scope.users = [newValue];
            $scope.searchWord = newValue.USERNAME;
        }
    });

    /**
     * [getGroupData description] 获取用户信息
     * @param  {[type]} node [description]
     * @return {[type]}      [description]
     */
    function getGroupData(node) {
        var params = {
            'serviceid': 'mlf_group',
            'methodname': 'getUsersByGroup',
            'GroupId': node.GROUPID,
        };
        requestData(params).then(function(data) {
            if (data.status !== undefined && data.status == '-1') {
                modalDialog.alertType('', '获取用户失败', 'error', false, function() {
                });
            } else {
                $scope.users = data;
                angular.forEach($scope.users, function(data, index, array) {
                    $scope.users[index].GROUPID = node.GROUPID;
                });
            }
        });
    }

    /**
     * [showToggle description] 打开当前树节点的下级子组
     * @param  {[type]} node [description]
     * @return {[type]}      [description]
     */
    $scope.showToggle = function(node) {
        childrenTree(node, function() {
        });
    };

    /**
     * [childrenTree description]获得下一级子组
     * @param  {[obj]}   node     [description]当前组信息
     * @param  {Function} callback [description]回调
     * @return {[type]}            [description]
     */
    function childrenTree(node, callback) {
        if (node.HASCHILDREN == 'true' && node.CHILDREN.length === 0) {
            var paramsT = {
                'serviceid': 'mlf_group',
                'methodname': 'queryChildGroupsWithOutRight',
                'GroupId': node.GROUPID,
            };
            trsHttpService.httpServer('/wcm/mlfcenter.do', paramsT, 'get').then(function(dataC) {
                    node.CHILDREN = dataC.CHILDREN;
                    callback();
                },
                function(dataC) {
                    modalDialog.alertType('', '获取子组失败', 'error', false);
                });
        }
    }

    /**
     * [userSelect description] 选中人员信息
     * @param  {[type]} user [description]
     * @return {[type]}      [description]
     */
    $scope.userSelect = function(user) {
        $scope.status.selectedUser = user;
    };

    /**
     * [requestData description]数据请求函数
     * @param  {[obj]} params [description]请求参数
     * @return {[obj]}        [description]请求返回值
     */
    function requestData(params) {
        var deffered = $q.defer();
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            deffered.resolve(data);
        });
        return deffered.promise;
    }

    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.close();
    };

}]);
